/* Filtres Book Nook — chargé par snippets/facets.liquid.
   1. <bn-price-slider> : barre à double curseur du filtre Prix, synchronisée
      dans les deux sens avec les champs De / À natifs (facets.js soumet le
      formulaire sur leur événement input ; les curseurs n'ont pas de name).
   2. Tiroir mobile en accordéon : les groupes restent des <details> natifs ;
      MenuDrawer (global.js) ne doit plus les traiter en panneaux glissants,
      et closeMenuDrawer les referme : on les rouvre à chaque ouverture. */

class BnPriceSlider extends HTMLElement {
  connectedCallback() {
    this.minC = Number(this.dataset.min) || 0;
    this.maxC = Number(this.dataset.max) || 0;
    this.step = Number(this.dataset.step) || 500;
    this.symbol = this.dataset.symbol || '';
    this.n = Math.max(1, Math.ceil((this.maxC - this.minC) / this.step));

    const holder = this.closest('price-range') || this.parentElement;
    const fields = holder.querySelectorAll('input.field__input');
    this.minField = fields[0];
    this.maxField = fields[1];
    this.inputs = {
      min: this.querySelector('[data-thumb="min"]'),
      max: this.querySelector('[data-thumb="max"]'),
    };
    this.bubbles = {
      min: this.querySelector('[data-for="min"]'),
      max: this.querySelector('[data-for="max"]'),
    };
    this.fill = this.querySelector('.bn-price-slider__fill');

    ['min', 'max'].forEach((k) => {
      const input = this.inputs[k];
      input.max = this.n;
      input.dataset.min = 0; /* facets.js (PriceRange) lit data-min/data-max */
      input.dataset.max = this.n; /* sur tout input au « change » : bornes neutres */
      input.addEventListener('input', () => this.onSlide(k));
      ['pointerdown', 'focus'].forEach((ev) =>
        input.addEventListener(ev, () => this.bubbles[k].classList.add('is-visible'))
      );
      ['pointerup', 'pointercancel', 'blur'].forEach((ev) =>
        input.addEventListener(ev, () => this.bubbles[k].classList.remove('is-visible'))
      );
    });
    [this.minField, this.maxField].forEach((f) => {
      if (!f) return;
      f.addEventListener('input', () => this.fromFields());
      f.addEventListener('change', () => this.fromFields());
    });
    this.fromFields();
  }

  cents(k) {
    return Math.min(this.minC + k * this.step, this.maxC);
  }

  stepFromCents(c, fallback) {
    if (Number.isNaN(c)) return fallback;
    return Math.min(this.n, Math.max(0, Math.round((c - this.minC) / this.step)));
  }

  parseField(field) {
    if (!field || field.value.trim() === '') return NaN;
    return Math.round(parseFloat(field.value.replace(/\s/g, '').replace(',', '.')) * 100);
  }

  amount(c) {
    return (c / 100).toFixed(2).replace('.', ',');
  }

  fromFields() {
    let a = this.stepFromCents(this.parseField(this.minField), 0);
    let b = this.stepFromCents(this.parseField(this.maxField), this.n);
    if (a > b) a = b;
    this.inputs.min.value = a;
    this.inputs.max.value = b;
    this.paint();
  }

  onSlide(k) {
    let a = Number(this.inputs.min.value);
    let b = Number(this.inputs.max.value);
    if (k === 'min' && a > b) {
      a = b;
      this.inputs.min.value = a;
    }
    if (k === 'max' && b < a) {
      b = a;
      this.inputs.max.value = b;
    }
    if (this.minField) this.minField.value = a === 0 ? '' : this.amount(this.cents(a));
    if (this.maxField) this.maxField.value = b === this.n ? '' : this.amount(this.cents(b));
    this.paint();
  }

  paint() {
    const a = Number(this.inputs.min.value);
    const b = Number(this.inputs.max.value);
    const pa = (a / this.n) * 100;
    const pb = (b / this.n) * 100;
    this.fill.style.left = `${pa}%`;
    this.fill.style.right = `${100 - pb}%`;
    this.bubbles.min.style.left = `${pa}%`;
    this.bubbles.max.style.left = `${pb}%`;
    this.bubbles.min.textContent = this.symbol + this.amount(this.cents(a));
    this.bubbles.max.textContent = this.symbol + this.amount(this.cents(b));
    /* curseurs superposés : celui qui peut encore bouger passe devant */
    const minOnTop = a === b ? a > this.n / 2 : false;
    this.inputs.min.style.zIndex = minOnTop ? 4 : 3;
    this.inputs.max.style.zIndex = minOnTop ? 3 : 4;
  }
}

if (!customElements.get('bn-price-slider')) customElements.define('bn-price-slider', BnPriceSlider);

/* Tiroir mobile : accordéon */
document.addEventListener(
  'click',
  (event) => {
    const summary = event.target.closest('.mobile-facets__details > summary');
    if (summary && summary.closest('menu-drawer.mobile-facets__wrapper')) event.stopPropagation();
  },
  true
);

document.addEventListener(
  'toggle',
  (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    if (!details.classList.contains('mobile-facets__disclosure')) return;
    details.querySelectorAll('.mobile-facets__details').forEach((group) => {
      group.open = true;
    });
  },
  true
);
